module.exports = __webpack_public_path__ + "img/cross.efb6d35c.svg";